import { Close16, Close24, IconProps } from '@honeybook/icons';
import React from 'react';
import styled, { css } from 'styled-components';
import { hideInPrint } from '../../styles/mixins';
import { MustIncludeOneOfBasicTestIdProps } from '../common/internal/test-id.types';
import HBIconButton, { IIconButtonProps } from '../HBIconButton/HBIconButton';

export interface HBCloseButtonProps {
    onClick: IIconButtonProps['onClick'];
    /** Visual theme controlling the button's background/icon colors; 'light' uses light-invisible, 'dark' uses neutral-invisible. */
    theme?: 'light' | 'dark';
    size: Exclude<IIconButtonProps['size'], 'xl' | 'xxs'>;
    /** Pixel offset from the top-right corner of the positioned parent; applied to both `top` and `right`. */
    distance: number;
}

const HBCloseButton = ({
    onClick,
    theme = 'light',
    size,
    testId,
    testIdName,
    distance
}: HBCloseButtonProps & MustIncludeOneOfBasicTestIdProps) => {
    return (
        <IconButton
            size={size}
            $distance={distance}
            onClick={onClick}
            label="close"
            testId={testId}
            testIdName={testIdName}
            icon={SIZE_TO_ICON_MAP[size]}
            buttonTheme={THEME_TO_BUTTON_THEME[theme]}
        />
    );
};

export default HBCloseButton;

// -------------------------- Styles -------------------------- //

const SIZE_TO_ICON_MAP: Record<
    HBCloseButtonProps['size'],
    (props: IconProps) => JSX.Element
> = {
    xs: Close16,
    sm: Close24,
    md: Close24,
    lg: Close24
};

const THEME_TO_BUTTON_THEME: Record<
    HBCloseButtonProps['theme'],
    IIconButtonProps['buttonTheme']
> = {
    dark: 'neutral-invisible',
    light: 'light-invisible'
};

const IconButton = styled(HBIconButton)<{ $distance: number }>`
    ${hideInPrint}
    position: absolute;
    ${({ $distance }) => css`
        top: ${$distance}px;
        right: ${$distance}px;
    `}
`;
